// extracted by mini-css-extract-plugin
var _1 = "ProStatus-module__settingsPro___np2eZ";
var _2 = "ProStatus-module__subtitle___YsaV6";
export { _1 as "settingsPro", _2 as "subtitle" }
